var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 60",
    style: {
      enableBackground: "new 0 0 180 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#D7CCFF;}\n\t.st3{fill:#B198F8;}\n\t.st4{fill:#8258F3;}\n\t.st5{fill:#250051;}\n\t.st6{fill:#E8546A;}\n\t.st7{fill:#D32D40;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.5,49.9L65,49.2c-1.9,0-3.8-0.2-5.6-0.4c-12.7-1.7-19.6-14.1-12.8-23.6c4.7-6.6,15-11.3,36.8-6.1 c4.4,1,8.8,1.8,12.1,4.6l0,0c4.5,3.8,10.9,5.4,17,4.2l7.1-1.3c0.8-0.1,1.4-0.5,2.2-0.6c12.4-1.9,17.6,2.3,19.1,7.3s-2,11.7-8.5,13.6 l0,0C125.7,48.9,118.6,49.9,111.5,49.9L111.5,49.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 66.3,
    y: 24.5,
    className: "st1",
    width: 18.3,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.8,30.3H56.5l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L74.8,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.4,24.5h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H74.4c-0.3,0-0.5-0.2-0.5-0.5l0,0 C73.9,24.7,74.1,24.5,74.4,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.4,29.3h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H74.4c-0.3,0-0.5-0.2-0.5-0.5l0,0 C73.9,29.5,74.1,29.3,74.4,29.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.4,
    y: 30.4,
    className: "st1",
    width: 18.3,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.9,36.2H59.6l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L77.9,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.5,30.4h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H77.5c-0.3,0-0.5-0.2-0.5-0.5l0,0 C77,30.6,77.2,30.4,77.5,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.5,35.2h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H77.5c-0.3,0-0.5-0.2-0.5-0.5l0,0 C77,35.4,77.2,35.2,77.5,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.9,36.2H58.6l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L76.9,36.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.8,
    y: 18.5,
    className: "st1",
    width: 18.3,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.2,24.4H60.9l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L79.2,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.8,18.5h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H78.8c-0.3,0-0.5-0.2-0.5-0.5l0,0 C78.3,18.7,78.5,18.5,78.8,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.8,23.3h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H78.8c-0.3,0-0.5-0.2-0.5-0.5l0,0 C78.3,23.5,78.5,23.3,78.8,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M78.2,24.4H59.9l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L78.2,24.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.1,
    y: 12.6,
    className: "st1",
    width: 18.3,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.6,18.4H63.3l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L81.6,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.2,12.6h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H81.2c-0.3,0-0.5-0.2-0.5-0.5l0,0 C80.7,12.8,80.9,12.6,81.2,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.2,17.4h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H81.2c-0.3,0-0.5-0.2-0.5-0.5l0,0 C80.7,17.6,80.9,17.4,81.2,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80.5,18.4H62.2l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L80.5,18.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.1,
    y: 7.5,
    className: "st1",
    width: 18.3,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.5,12.5H59.2l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L77.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M87.8,5.1L76.6,7.7c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.6,0.5-0.6L87.8,4c0.3,0,0.5,0.2,0.5,0.5l0,0 C88.3,4.8,88.1,5.1,87.8,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.1,11.4H88c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H77.1c-0.3,0-0.5-0.2-0.5-0.5l0,0 C76.6,11.6,76.8,11.4,77.1,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.5,12.5H58.2l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L76.5,12.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "58.2,6.6 76.5,6.6 87.8,4 71.4,4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.3,
    y: 48.2,
    className: "st1",
    width: 18.3,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.8,54.1H58.5l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L76.8,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.4,48.2h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H76.4c-0.3,0-0.5-0.2-0.5-0.5l0,0 C75.9,48.4,76.1,48.2,76.4,48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.4,53h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H76.4c-0.3,0-0.5-0.2-0.5-0.5l0,0 C75.9,53.2,76.1,53,76.4,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.8,54.1H57.5l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L75.8,54.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4,
    y: 54.2,
    className: "st1",
    width: 18.3,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.9,60H61.6l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L79.9,60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.5,54.2h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H79.5c-0.3,0-0.5-0.2-0.5-0.5l0,0 C79,54.4,79.2,54.2,79.5,54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.5,59h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H79.5c-0.3,0-0.5-0.2-0.5-0.5l0,0 C79,59.2,79.2,59,79.5,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.9,60H60.6l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L78.9,60z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 42.3,
    className: "st1",
    width: 18.3,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.7,48.1H63.4l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L81.7,48.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.3,42.3h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H81.3c-0.3,0-0.5-0.2-0.5-0.5l0,0 C80.8,42.5,81,42.3,81.3,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.3,47.1h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H81.3c-0.3,0-0.5-0.2-0.5-0.5l0,0 C80.8,47.3,81,47.1,81.3,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M80.7,48.1H62.4l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L80.7,48.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.1,
    y: 36.4,
    className: "st1",
    width: 18.3,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M79.6,42.2H61.3l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L79.6,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M79.2,36.4h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H79.2c-0.3,0-0.5-0.2-0.5-0.5l0,0 C78.7,36.6,78.9,36.4,79.2,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M79.2,41.1h10.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5H79.2c-0.3,0-0.5-0.2-0.5-0.5l0,0 C78.7,41.3,78.9,41.1,79.2,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.5,42.2H60.2l-0.4-1c-0.4-1.2-0.4-2.6,0-3.8l0.4-1h18.3l-0.4,1c-0.4,1.2-0.4,2.6,0,3.8L78.5,42.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration3);
export default __webpack_public_path__ + "static/media/illustration3.12b7f1bb1c96901838723fe4c5b98bdd.svg";
export { ForwardRef as ReactComponent };